import React, { useCallback, useEffect, useRef, useState } from 'react';
import { MailIcon, StarIcon, ReplyIcon } from 'lucide-react';
import { Stars } from './Stars';
type GmailReview = {
  name: string;
  initial: string;
  color: string;
  email: string;
  subject: string;
  time: string;
  body: string;
};
const reviews: GmailReview[] = [{
  name: 'Dra. Carolina Ferreyra',
  initial: 'C',
  color: 'bg-rose-500',
  email: 'caro.ferreyra@gmail.com',
  subject: 'Gracias! Por fin ordené los presupuestos',
  time: '10:42',
  body: 'Hola! Compré el kit el martes y el mismo día armé 6 presupuestos con la planilla dinámica. Antes tardaba 40 minutos por paciente, ahora 5. Mil gracias.'
}, {
  name: 'Dr. Martín Sosa',
  initial: 'M',
  color: 'bg-sky-600',
  email: 'martinsosa.odo@gmail.com',
  subject: 'Recién descubro cuánto perdía por hora',
  time: '18:07',
  body: 'La calculadora de costo por hora me abrió los ojos. Estaba cobrando conductos por debajo del costo real. Ya reajusté toda la lista de precios.'
}, {
  name: 'Dra. Luciana Pérez',
  initial: 'L',
  color: 'bg-violet-600',
  email: 'luciana.perez.odont@gmail.com',
  subject: 'El control de stock me salvó',
  time: 'Ayer',
  body: 'No me quedé más sin composite un viernes a la tarde. Cargo todo una vez por semana y la planilla me avisa qué reponer. Simple y funciona.'
}, {
  name: 'Dr. Federico Aguirre',
  initial: 'F',
  color: 'bg-emerald-600',
  email: 'fede.aguirre.dental@gmail.com',
  subject: 'Los contratos valen el precio solos',
  time: 'Ayer',
  body: 'Contraté recepcionista y usé el modelo de contrato del bonus. Mi contadora lo revisó y no le cambió nada. Excelente material.'
}];
export function GmailReviews() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const handleScroll = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    const index = Math.round(el.scrollLeft / el.clientWidth);
    setActive(Math.min(reviews.length - 1, Math.max(0, index)));
  }, []);
  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;
    el.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);
  const goTo = (i: number) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollTo({
      left: i * el.clientWidth,
      behavior: 'smooth'
    });
  };
  return <section className="py-10" aria-label="Opiniones recibidas por mail" data-id="element-102" data-mp="ql71l1ojn3kx">
      <div ref={trackRef} className="flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-103" data-mp="vk9x9vimvxg8">
        {reviews.map(r => <article key={r.email} className="w-full shrink-0 snap-center rounded-2xl border border-slate-200 bg-white p-4 shadow-lg shadow-black/20" data-id="element-104" data-mp="19dj4pqn0u8w4">
            <div className="flex items-start gap-3" data-id="element-105" data-mp="1ea9i267fyqdu">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white ${r.color}`} aria-hidden="true" data-id="element-106" data-mp="2yvpod8i0988m">
                {r.initial}
              </div>
              <div className="min-w-0 flex-1" data-id="element-107" data-mp="2pvt6bpq4f7mj">
                <div className="flex items-center justify-between gap-2" data-id="element-108" data-mp="2kvx2prlc5i7i">
                  <p className="truncate text-sm font-semibold text-slate-900" data-id="element-109" data-mp="3hlnxzt1gb9ed">
                    {r.name}
                  </p>
                  <span className="shrink-0 text-[11px] text-slate-500" data-id="element-110" data-mp="3dku7qt0jdiib">
                    {r.time}
                  </span>
                </div>
                <p className="truncate text-[11px] text-slate-500" data-id="element-111" data-mp="33tr9s02wljn9">
                  para mí · {r.email}
                </p>
                <p className="mt-1 text-sm font-bold text-slate-900" data-id="element-112" data-mp="53zgkat3pmk2">
                  {r.subject}
                </p>
                <p className="mt-1 text-[13px] leading-relaxed text-slate-700" data-id="element-113" data-mp="c915qfb48ls">
                  {r.body}
                </p>
                <div className="mt-3 flex items-center gap-4 text-slate-400" data-id="element-114" data-mp="3g1l0l11vv3we">
                  <ReplyIcon className="h-4 w-4" aria-hidden="true" data-id="element-115" data-mp="3l2s9j3fri94n" />
                  <StarIcon className="h-4 w-4" aria-hidden="true" data-id="element-116" data-mp="372zj7985dux7" />
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-117" data-mp="3c1at1jyg05ff" />
                </div>
              </div>
            </div>
          </article>)}
      </div>

      <div className="mt-4 flex items-center justify-center gap-2" data-id="element-118" data-mp="3m0s4f6ah698">
        {reviews.map((r, i) => <button key={r.email} type="button" onClick={() => goTo(i)} aria-label={`Ver opinión ${i + 1} de ${reviews.length}`} aria-current={active === i} className={`h-2 rounded-full transition-all ${active === i ? 'w-6 bg-teal-400' : 'w-2 bg-white/25'}`} data-id="element-119" data-mp="7maznw9qc4q7" data-mpi={i} />)}
      </div>
      <p className="mt-2 text-center text-[11px] text-teal-100/50" data-id="element-120" data-mp="rcmpncio384z">
        Deslizá para ver más opiniones
      </p>

      <div className="mt-6 flex flex-col items-center gap-2 px-5" data-id="element-121" data-mp="10nsm2ewevu02">
        <Stars size={24} data-id="element-122" data-mp="wnig328md3l7" />
        <p className="text-lg font-extrabold text-white" data-id="element-123" data-mp="wm7dh5qwu1vo">4.9/5</p>
        <p className="text-center text-xs text-teal-100/70" data-id="element-124" data-mp="1aen93lhhexmk">
          Basado en las opiniones de odontólogos que ya usan el kit
        </p>
      </div>
    </section>;
}